export const visit = (vm, at) => {
at({ "fr": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Vous rencontrez des probl\xE8mes lors du visionnage de cette vid\xE9o\xA0?", "playButton": "Lecture" } } });
};